export const TENANT_UK = 'uk';
export const TENANT_AU = 'au';
export const TENANT_NZ = 'nz';
export const TENANT_ES = 'es';
export const TENANT_IE = 'ie';
export const TENANT_IT = 'it';

export const SUPPORTED_TENANTS = [
    TENANT_UK,
    TENANT_AU,
    TENANT_NZ,
    TENANT_ES,
    TENANT_IE,
    TENANT_IT
];
